import type {RunCopperOverlapDrcType, SerializedInputs, ValidatorOutput} from "@buildwithflux/core";
import * as Comlink from "comlink";

interface CopperOverlapWorkerApi {
    runCopperOverlapDrcInWorker(inputs: SerializedInputs): Promise<ValidatorOutput>;
}

const worker = new Worker(new URL("./copperOverlapWorker.ts", import.meta.url), {type: "module"});
const comlink = Comlink.wrap<CopperOverlapWorkerApi>(worker);

export const workerRunCopperOverlapDrc = comlink.runCopperOverlapDrcInWorker as RunCopperOverlapDrcType;
